<script>
  import { Router, Route } from "svelte-routing";
  import Home from "./Home.svelte";
  import FAQ from "./FAQ.svelte";
  import Press from "./Press.svelte";
  import Gallery from "./Gallery.svelte";
  import Swiper from "./Swiper.svelte";
  import Footer from "./Footer.svelte";
  import ViewBoy from "./ViewBoy.svelte";
  import ViewBoySmol from "./ViewBoySmol.svelte";
  export let url = "";
</script>

<Router {url}>
  <Route path="/"><Home /></Route>
  <Route path="/faq" component={FAQ} />
  <Route path="/press" component={Press} />
  <Route path="/gallery" component={Gallery} />
  <Route path="/swiper" component={Swiper} />
  <Route path="/smol/:id" component={ViewBoySmol} />
  <Route path="/boy/genesis/:id" component={ViewBoy} />
  <Route path="/boy/:id" component={ViewBoy} />
  <Footer />
</Router>


<style global lang="postcss">
  @tailwind base;
  @tailwind components;
  @tailwind utilities;

  @font-face {
    font-family: "Arcade";
    src: url("/font/Arcade.woff2") format("woff2"),
      url("/font/Arcade.woff") format("woff");
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "Pixel";
    src: url("/font/04b30.woff2") format("woff2"),
      url("/font-/04b30.woff") format("woff");
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  html,
  head,
  body {
    min-height: 100%;
    position: relative;
  }

  body {
    color: #000;
    /* background-color: #FBCFE8;rgb(63, 60, 135); */
  }
</style>
